import { Injectable, ViewContainerRef} from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { fromEvent, Subscription, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MenuContextualService {

  overlayRef: any;
  sub: Subscription;

  private afterClosed = new Subject<any>();
  onClosed = this.afterClosed.asObservable();


  constructor(public overlay: Overlay) { }
 open1({ x, y }: MouseEvent, viewContainerRef: ViewContainerRef, user,userdata, origin, menuTemplate, isProfileTemplate: boolean = false) {
    this.close();
    if (isProfileTemplate) {
      y = 0;
      x = screen.availWidth;
    }
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: 'center',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'top',
        },
        {
          originX: 'center',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'center',
        },
        {
          originX: 'end',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'bottom',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(menuTemplate, viewContainerRef, {
      $implicit: user, close: this.close
    }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return clickTarget !== origin;
        }),
        take(1)
      ).subscribe(() => this.close());
  }
  open({ x, y }: MouseEvent, viewContainerRef: ViewContainerRef, user, origin, menuTemplate, isProfileTemplate: boolean = false) {
    this.close();
    if (isProfileTemplate) {
      y = 0;
      x = screen.availWidth;
    }
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: 'center',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'top',
        },
        {
          originX: 'center',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'center',
        },
        {
          originX: 'end',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'bottom',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(menuTemplate, viewContainerRef, {
      $implicit: user, close: this.close
    }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return clickTarget !== origin;
        }),
        take(1)
      ).subscribe(() => this.close());
  }
    close() {
        this.sub && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }
}
